import styled from 'styled-components';

const FormGroup = styled.div`
	margin-bottom: 18px;

	@media (min-width: 768px) {
		margin-bottom: 25px;
	}
`;

export default FormGroup;
